import styled from "styled-components";
import {Avatar} from "@material-ui/core";

export const AvatarStyled = styled(Avatar)`
  width: 60px;
  height: 60px;
  border-radius: 10px;
`;